export interface SpeechLanguage {
  code: string;
  label: string;
}

/**
 * Op label gesorteerd, want zo komt de lijst in de keuzelijsten terecht -- daar
 * wordt hij gelezen en niet doorzocht op taalcode. Een nieuwe taal hoort dus op zijn
 * alfabetische plek; azure-languages.test.ts houdt dat bij.
 */
export const AZURE_SPEECH_LANGUAGES: SpeechLanguage[] = [
  { code: 'af-ZA', label: 'Afrikaans' },
  { code: 'ar-SA', label: 'Arabisch' },
  { code: 'ar-MA', label: 'Arabisch (Marokko)' },
  { code: 'eu-ES', label: 'Baskisch' },
  { code: 'bn-IN', label: 'Bengaals' },
  { code: 'bg-BG', label: 'Bulgaars' },
  { code: 'ca-ES', label: 'Catalaans' },
  { code: 'zh-CN', label: 'Chinees (Mandarijn)' },
  { code: 'da-DK', label: 'Deens' },
  { code: 'de-DE', label: 'Duits' },
  { code: 'en-GB', label: 'Engels (VK)' },
  { code: 'en-US', label: 'Engels (VS)' },
  { code: 'fi-FI', label: 'Fins' },
  { code: 'fr-FR', label: 'Frans' },
  { code: 'fr-BE', label: 'Frans (België)' },
  { code: 'gl-ES', label: 'Galicisch' },
  { code: 'el-GR', label: 'Grieks' },
  { code: 'he-IL', label: 'Hebreeuws' },
  { code: 'hi-IN', label: 'Hindi' },
  { code: 'hu-HU', label: 'Hongaars' },
  { code: 'ga-IE', label: 'Iers' },
  { code: 'id-ID', label: 'Indonesisch' },
  { code: 'it-IT', label: 'Italiaans' },
  { code: 'ja-JP', label: 'Japans' },
  { code: 'ko-KR', label: 'Koreaans' },
  { code: 'hr-HR', label: 'Kroatisch' },
  { code: 'ms-MY', label: 'Maleis' },
  { code: 'nl-NL', label: 'Nederlands' },
  { code: 'nb-NO', label: 'Noors' },
  { code: 'uk-UA', label: 'Oekraïens' },
  { code: 'fa-IR', label: 'Perzisch' },
  { code: 'pl-PL', label: 'Pools' },
  { code: 'pt-PT', label: 'Portugees' },
  { code: 'pt-BR', label: 'Portugees (Brazilië)' },
  { code: 'ro-RO', label: 'Roemeens' },
  { code: 'ru-RU', label: 'Russisch' },
  { code: 'sr-RS', label: 'Servisch' },
  { code: 'sl-SI', label: 'Sloveens' },
  { code: 'sk-SK', label: 'Slowaaks' },
  { code: 'es-ES', label: 'Spaans' },
  { code: 'sw-KE', label: 'Swahili' },
  { code: 'ta-IN', label: 'Tamil' },
  { code: 'te-IN', label: 'Telugu' },
  { code: 'th-TH', label: 'Thai' },
  { code: 'cs-CZ', label: 'Tsjechisch' },
  { code: 'tr-TR', label: 'Turks' },
  { code: 'ur-PK', label: 'Urdu' },
  { code: 'vi-VN', label: 'Vietnamees' },
  { code: 'cy-GB', label: 'Welsh' },
  { code: 'sv-SE', label: 'Zweeds' },
];

/**
 * De standaardtaal, opgezocht op code en niet op positie.
 *
 * Dit was `AZURE_SPEECH_LANGUAGES[0]`, wat klopte zolang Nederlands bovenaan stond.
 * Sinds de lijst alfabetisch is, staat daar Afrikaans -- en een standaardtaal die
 * meeschuift met de sorteervolgorde is geen standaard.
 */
export const DEFAULT_SPEECH_LANGUAGE: SpeechLanguage =
  AZURE_SPEECH_LANGUAGES.find((taal) => taal.code === 'nl-NL')!;
